Core.JobsRouter = Core.SubRouter.extend({
    routes: {
        '': 'jobs',
        'newlist': 'jobsNew',
        'oldlist': 'jobsOld',
        'mine': 'mine',
        'all': 'all',
        'unassigned': 'unassigned',
        'templates': 'templates',
        'today': 'today',
        'ongoing': 'ongoing',
        'late': 'late',
        'scheduled': 'scheduled',
        'user/:id': 'jobsForUser',
        'customer/:id': 'jobsForCustomer',
        'summary': 'jobSummary',
		'import': 'importJob',
        'accept/:id': 'acceptJob',

        'new': 'newJob',
        ':id/edit': 'editJob',
        ':id/copy': 'copyJob',
        ':id/sign': 'signJob',
        ':id': 'viewJob',

    },

    viewJob: function (id) {
        debug.log('view job', id);
        var view = new JobDetailsView({
            sharedView: typeof Core.param('shared') != 'undefined',
            customerView: typeof Core.param('customer') != 'undefined' && isNaN(parseInt(Core.param('customer')))
        });
        if (Core.param('returnTo')) view.saveAction = Core.param('returnTo');

        view.editing = false;
        if (!view.model || view.model.id != id) view.setModel(new Job({id: id}));
        app.setMainView(view, Core.param('template') != undefined ? 'directory' : 'jobs');
    },

    jobs: function (route) {
        debug.log('jobs');
        var view = new JobListNewView({scrolling: true});
        view.fetchList('all');
        app.setMainView(view, 'jobs', { wideContainer: true});
    },

    jobsNew: function (route) {
        return this.jobs(route);
    },

    jobsOld: function (route) {
        debug.log('jobs old');
        var view = new JobListView({scrolling: true});
        view.fetchList('all');
        app.setMainView(view, 'jobs', { wideContainer: true});
    },

    mine: function () {
        debug.log('my jobs');
        var view = new JobListNewView({scrolling: true});
        view.selectList('mine');
        app.setMainView(view, 'jobs', { wideContainer: true});
    },

    all: function () {
        debug.log('all jobs');
        var view = new JobListNewView({scrolling: true});
        view.selectList('all');
        app.setMainView(view, 'jobs', { wideContainer: true});
    },

    unassigned: function () {
        debug.log('unassigned jobs');
        var view = new JobListNewView({scrolling: true});
        view.selectList('unassigned');
        app.setMainView(view, 'jobs', { wideContainer: true});
    },

    templates: function () {
        debug.log('job templates');
        var view = new JobListView({scrolling: true});
        view.fetchList('templates');
        app.setMainView(view, 'jobs', { wideContainer: true});
    },

    today: function () {
        debug.log('jobs today');
        var view = new JobListNewView({scrolling: true});
        view.selectList('today');
        app.setMainView(view, 'jobs', { wideContainer: true});
    },

    ongoing: function () {
        debug.log('ongoing jobs');
        var view = new JobListNewView({scrolling: true});
        view.selectList('ongoing');
        app.setMainView(view, 'jobs', { wideContainer: true});
    },

    late: function () {
        debug.log('late jobs');
        var view = new JobListNewView({scrolling: true});
        view.selectList('late');
        app.setMainView(view, 'jobs', { wideContainer: true});
    },

    scheduled: function() {
        debug.log('scheduled jobs');
        var view = new JobListNewView({scrolling: true});
        view.selectList('scheduled');
        app.setMainView(view, 'jobs', { wideContainer: true });
    },

    jobsForUser: function (id) {
        debug.log('jobs for user:', id);
        var view = new JobListView({scrolling: true});
        view.selectList('user-'+id);
        app.setMainView(view, 'jobs', { wideContainer: true});
    },

    jobsForCustomer: function (id) {
        debug.log('jobs for customer:', id);
        var view = new JobListView({scrolling: true});
        view.selectList('customer-'+id);
        app.setMainView(view, 'jobs', { wideContainer: true});
    },

    jobSummary: function () {
        debug.log('job summary');
        app.setMainView(new JobSummaryView(), 'jobs');
    },

	importJob: function () {
		debug.log('import jobs');
		app.setMainView(new JobImportView(), 'jobs');
	},

    acceptJob: function (id) {
        debug.log('accept job');
        app.setMainView(new JobAcceptView({id: id}), 'jobs');
    },

    newJob: function () {
        debug.log('new job');
        var view = new JobDetailsView({
            sharedView: typeof Core.param('shared') != 'undefined',
            customerView: typeof Core.param('customer') != 'undefined' && isNaN(parseInt(Core.param('customer')))
        });
        if (Core.param('returnTo')) view.saveAction = Core.param('returnTo');

        view.editing = true;
        view.loading = false;
        view.fillInDefaults();
        app.setMainView(view, Core.param('template') != undefined ? 'directory' : 'jobs');
    },

    editJob: function (id) {
        debug.log('edit job', id);
        var view = new JobDetailsView({
            sharedView: typeof Core.param('shared') != 'undefined',
            customerView: typeof Core.param('customer') != 'undefined' && isNaN(parseInt(Core.param('customer')))
        });
        if (Core.param('returnTo')) view.saveAction = Core.param('returnTo');

        view.editing = true;
        if (!view.model || view.model.id != id) view.setModel(new Job({id: id}));
        else view.change();
        app.setMainView(view, Core.param('template') != undefined ? 'directory' : 'jobs');
    },

    copyJob: function (id) {
        debug.log('copy job', id);
        var view = new JobDetailsView({
            sharedView: typeof Core.param('shared') != 'undefined',
            customerView: typeof Core.param('customer') != 'undefined' && isNaN(parseInt(Core.param('customer')))
        });
        if (Core.param('returnTo')) view.saveAction = Core.param('returnTo');

        view.editing = true;
        var template = new Job();
        template.set(JSON.parse(sessionStorage['core_job_template']));
        var job = new Job();
        job.setFromTemplate(template);
        if (template.get('title'))
            job.set('title', template.get('title'));
        view.selectedTemplate = template;
        view.modelIsCopy = true;
        view.setModel(job);
        app.setMainView(view, 'jobs');
    },

    signJob: function (id) {
        var job;
        if ('signJob' in sessionStorage) {
            job = new Job(JSON.parse(sessionStorage.signJob));
            if (job.id == id) {
                job.loaded = true;
                debug.log('signJob from session');
            } else {
                job.loaded = false;
                job.reset({id: id});
            }
            delete sessionStorage.signJob;
        } else {
            job = new Job({id: id});
        }
        app.setMainView(new SignView({model: job}));
    },

});
